<template>
  <div>
    <b-alert :show="errors.length > 0">
      <p v-for="item in errors" v-bind:key="item">{{ item }}</p>
    </b-alert>
    <!-- <div>asd:{{item.type.id}}</div> -->
    <div v-if="item.type.id == '1501'">
      <b-form-group label="تلفن همراه:" label-for="mobile">
        <b-form-input
          id="mobile"
          v-model="mobile"
          :disabled="true"
          placeholder="تلفن همراه"
        ></b-form-input>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group label="کد ارسالی:">
            <b-form-input
              id="mobilecode"
              v-model="confirmCode"
              placeholder="کد ارسال شده"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="pt-9">
          <b-button
            variant="warning"
            :class="Loading ? 'spinner spinner-light spinner-right' : ''"
            @click="PrepareValidate()"
            :disabled="timer > 0"
          >
            ارسال مجدد
            <span v-if="timer > 0">({{ timer }})</span>
          </b-button>
          <b-button
            variant="primary"
            :class="submitLoading ? 'spinner spinner-light spinner-right' : ''"
            @click="Validate()"
            class="ml-3"
            >تایید</b-button
          >
        </b-col>
      </b-row>
    </div>

    <div v-if="item.type.id == '1502'">
      <b-form-group label="پست الکترونیکی:" label-for="email">
        <b-form-input
          id="email"
          v-model="email"
          :disabled="true"
          placeholder="پست الکترونیکی"
        ></b-form-input>
      </b-form-group>
      <p>
        لینک تایید برای پست الکترونیکی شما ارسال شده است، بر روی لینک کلیک و پست
        الکترونیکی را تایید کنید
      </p>
      <b-row>
        <b-col>
          <b-button
            :disabled="btn_disable"
            variant="primary"
            @click="Validate()"
            class="ml-3"
            >ارسال لینک تایید</b-button
          >
        </b-col>
      </b-row>
    </div>

    <div v-if="item.type.id == '1503'">
      <b-form-group label="تلفن ثابت:" label-for="phone">
        <b-form-input
          id="phone"
          v-model="phone"
          :disabled="true"
          placeholder="تلفن ثابت"
        ></b-form-input>
      </b-form-group>
      <p>
        بر روی گزینه ی تماس کلیک کنید تا با شما تماس گرفته شود و کد تایید برای
        شما خوانده شود
      </p>
      <b-row>
        <b-col>
          <b-form-group label="کد خوانده شده">
            <b-form-input
              id="phoneCode"
              @keyup="setENChars('')"
              v-model="confirmCode"
              placeholder="کد خوانده شده"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="pt-9">
          <b-button
            variant="warning"
            :class="Loading ? 'spinner spinner-light spinner-right' : ''"
            :disabled="timer > 0"
            @click="PrepareValidate()"
          >
            تماس
            <span v-if="timer > 0">({{ timer }})</span>
          </b-button>
          <b-button
            variant="primary"
            :class="submitLoading ? 'spinner spinner-light spinner-right' : ''"
            @click="Validate()"
            class="ml-3"
            >تایید</b-button
          >
        </b-col>
      </b-row>
    </div>

    <div v-if="item.type.id == '1504'">
      <b-form-group label="آدرس سکونت:" label-for="phone">
        <b-form-textarea
          id="address"
          v-model="address"
          :disabled="true"
          placeholder
        ></b-form-textarea>
      </b-form-group>
      <p>
        پاکت نامه شامل کد تایید آدرس برای شما ارسال شده است، کد مورد نظر را در
        زیر وارد کرده و تایید کنید
      </p>
      <b-row>
        <b-col>
          <b-form-input
            id="addressCode"
            v-model="confirmCode"
            placeholder="کد دریافت شده"
          ></b-form-input>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :class="submitLoading ? 'spinner spinner-light spinner-right' : ''"
            @click="Validate()"
            class="ml-3"
            >تایید</b-button
          >
        </b-col>
      </b-row>
    </div>

    <div v-if="item.type.id == '1505'">
      <div v-if="item.status.id == 1520">
        <p>
          عکس با کیفیت متوسط از کارت ملی در صورتی که آن را رو به روی خود گرفته
          اید و به صورت سلفی عکس میگیرید را در زیر بارگذاری کنید
        </p>
        <b-row>
          <b-col>
            <FileUploader v-model="confirmCode"></FileUploader>
          </b-col>
          <b-col>
            <b-button variant="primary" @click="Validate()" class="ml-3"
              >ذخیره عکس</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-img
              :src="'https://api.shepa.com/api/file/' + confirmCode"
              fluid
            ></b-img>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-if="item.status.id == 1521">
        <b-alert variant="warning" show
          >کارت ملی شما به همراه سلفی در حال تایید توسط مدیریت می باشد</b-alert
        >
      </div>
      <div v-if="item.status.id == 1522">
        <b-alert variant="success" show
          >کارت ملی شما به همراه سلفی تایید شده است</b-alert
        >
      </div>
    </div>
    <div v-if="item.type.id == '1506'">
      <div v-if="item.status.id == 1520">
        <p>اسکن کارت ملی خود را در زیر بارگذاری نمایید</p>
        <b-row>
          <b-col>
            <FileUploader v-model="confirmCode"></FileUploader>
          </b-col>
          <b-col>
            <b-button variant="primary" @click="Validate()" class="ml-3"
              >ذخیره عکس</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-img
              :src="'https://api.shepa.com/api/file/' + confirmCode"
              fluid
            ></b-img>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-if="item.status.id == 1521">
        <b-alert variant="warning" show
          >کارت ملی شما در حال تایید توسط مدیریت می باشد</b-alert
        >
      </div>
      <div v-if="item.status.id == 1522">
        <b-alert variant="success" show>کارت ملی شما تایید شده است</b-alert>
      </div>
    </div>
    <div v-if="item.type.id == '1736'">
      <div v-if="item.status.id == 1520">
        <p>اسکن مجوز کسب و کار خود را در زیر بارگذاری نمایید</p>
        <b-row>
          <b-col md="8" sm="6" cols="12">
            <FileUploader v-model="confirmCode"></FileUploader>
          </b-col>
          <b-col md="4" sm="6" cols="12">
            <b-button variant="primary" @click="Validate()" class="ml-3"
              >ذخیره عکس</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-img
              :src="'https://api.shepa.com/api/file/' + confirmCode"
              fluid
            ></b-img>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div v-if="item.status.id == 1521">
        <b-alert variant="warning" show
          >مجوز کسب و کار شما در حال تایید توسط مدیریت می باشد</b-alert
        >
      </div>
      <div v-if="item.status.id == 1522">
        <b-alert variant="success" show>مجوز کسب و کار شما تایید شده است</b-alert>
      </div>
    </div>
    <!-- const submitButton = this.$refs["kt_login_signin_submit"];
    submitButton.classList.add("spinner", "spinner-light", "spinner-right");-->
    <!-- <div v-if="item.type.id == '1506'">
      <p>تایید کد ملی با استفاده از سامانه ی هدا انجام می شود</p>
      <p>برای تایید کد ملی خود روی دکمه ی زیر کلیک کنید تا به سامانه ی هدا متصل شوید</p>
    </div>-->
  </div>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import FileUploader from "../../components/fileUploader";
export default {
  name: "ConfirmationDetails",
  data: function () {
    return {
      item: { type: {} },
      mobile: "",
      confirmCode: "",
      email: "",
      phone: "",
      address: "",
      timer: 0,
      timeInterval: "",
      Loading: false,
      submitLoading: false,
      btn_disable: false,
      errors: [],
    };
  },
  components: {
    FileUploader,
  },
  props: ["foritem", "afterverified", "dataUpdated"],
  watch: {
    foritem: function (newVal, oldVal) {
      this.item = newVal;
    },
    dataUpdated: function (newVal, oldVal) {
      this.mobile = "";
      this.email = "";
      this.phone = "";
      this.refreshDatas();
    },
  },
  created() {
    this.item = this.foritem;
  },
  methods: {
    setCollectTimeOut() {
      this.btn_disable = false;
      this.afterverified();
      this.timer = 0;
    },
    PrepareValidate() {
      if (this.timer > 0) {
        return;
      }
      this.Loading = true;
      httpHelper.postData("userconf/prepare", this.item).then((res) => {
        this.timer = 120;
        this.CalcTime();
        this.Loading = false;
      });
    },
    setENChars(field) {
      this.confirmCode = this.confirmCode.toEnDigits();
    },
    Validate() {
      this.item.confirmCode = this.confirmCode;
      this.errors = [];
      httpHelper.postData("userconf/validate", this.item).then((res) => {
        this.submitLoading = false;
        if (res.success) {
          if (res.result == true) {
            //this.$bvModal.hide("confirmationModal");
            if (this.item.mdid6_type == 1502) {
              this.btn_disable = true;
              this.errors.push("ایمیل تایید برای شما ارسال گردید");
            }
            setTimeout(() => this.setCollectTimeOut(), 9000);
          } else {
            this.errors.push("کد وارد شده صحیح نمی باشد");
          }
          this.afterverified();
        }
      });
    },
    CalcTime() {
      this.timeInterval = setInterval(() => {
        this.timer--;
        if (this.timer == 0) {
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
    refreshDatas() {
      httpHelper.getData("users/verify").then((res) => {
        this.mobile = res.mobile;
        this.email = res.email;
        this.phone = res.pre_phone + "-" + res.phone;
      });
    },
  },
  mounted() {
    this.refreshDatas();
  },
};
</script>
